import React from 'react';
import {Image, Text, View} from "@react-pdf/renderer";
import {styles} from "../styles";
import {imageByIndex} from "../../../../../helpers/imageByIndex";

const MainPage = ({data}) => {
  const { person } = data;
  const {photo, name, phone} = person;

  return (
    <View style={{marginTop: "100px"}}>
      {
        photo &&
        <Image
          style={styles.image}
          src={imageByIndex(photo)}
        />
      }
      <Text style={styles.title}>{name}</Text>
      <Text style={styles.phone}>{phone}</Text>
    </View>
  );
};

export default MainPage;